import type { DocTypeRepository } from "../repositories/doc-type-repository"

export const makeDeleteDocType = (repo: DocTypeRepository) => (id: string) =>
  repo.delete(id)
